<template>
    <div>
        <!-- Filters -->
        <div class="mb-3">
            <v-row justify="space-around">
                <v-radio-group hide-details row v-model="filters.status">
                    <v-radio label="Actif" value="active"/>
                    <v-radio label="Bloqué" value="blocked"/>
                    <v-radio label="Invitation en attente" value="pendingInvitation"/>
                </v-radio-group>
            </v-row>
        </div>
        <v-data-table
                :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50, 100]}"
                :headers="dynamicHeaders"
                :items="items"
                :items-per-page="50"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
                @click:row="$emit('user-selected', $event)">
        >
            <template v-slot:item.action="{item}">
              <div class="text-right">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click.stop="reInvite(item.id)" v-bind="attrs" v-on="on" :loading="reinviteLoading"><v-icon>mdi-send</v-icon></v-btn>
                  </template>
                  <span>Renvoyer une invitation</span>
                </v-tooltip>
              </div>

            </template>
        </v-data-table>
        <v-snackbar :bottom="true" :timeout="0" color="error" v-model="error">Une erreur est survenue
            <v-btn @click="fetch" dark text>Réessayer</v-btn>
        </v-snackbar>
      <v-snackbar bottom color="error" v-model="reinviteError" :timeout="5000">Une erreur est survenue lors de la ré-invitation de l'utilisateur.</v-snackbar>
    </div>
</template>

<script>
	export default {
		name: "UserTable",
		data() {
			return {
				filters: {
					status: "active"
				},
				headers: [
					{text: "Prénom", value: "firstName"},
					{text: "Nom", value: "lastName"},
					{text: "Email", value: "email"},
          {text: "", value: "action"},
				],
				items: [],
				loading: false,
				options: {},
				totalItems: 0,
				error: false,
				downloadError: false,
        reinviteError: false,
        reinviteLoading: false
			}
		},
		watch: {
			options: {
				handler() {
					this.fetch();
				},
				deep: true,
			},
			filters: {
				handler() {
					this.fetch();
				},
				deep: true,
			},
		},
		mounted() {
			this.fetch();
		},
    computed: {
      dynamicHeaders() {
        return this.filters.status !== "pendingInvitation" ? this.headers.filter(h => h.value !== "action") : this.headers;
      }
    },
		methods: {
			fetch() {
        this.items = [];
				this.loading = true;
				this.error = false;
				const {sortBy, sortDesc, page, itemsPerPage} = this.options;
				let url = this.$config.apiUrl
					+ "/v2/users?page=" + (page - 1)
					+ "&size=" + itemsPerPage
					+ "&" + this.filters.status + "=true";
				if (this.filters.status !== "active") {
					url+="&active=false"
                }
				if (sortBy.length) {
					url += "&sort=" + sortBy[0] + "," + (sortDesc[0] ? 'desc' : 'asc');
				}
				this.$http.get(url)
					.then(r => {
						this.items = r.data.content;
						this.totalItems = r.data.totalElements;
					})
					.catch((e) => this.error = true)
					.finally(() => this.loading = false)
			},
      reInvite(userId) {
        this.reinviteLoading = true;
        this.reinviteError = false;
        this.$http.post(this.$config.apiUrl + "/v2/users/" + userId + "/reinvite")
          .catch(() => this.reinviteError = true)
          .finally(() => this.reinviteLoading = false)
      }
		}
	}
</script>

<style scoped>

</style>
